import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './components/notification/notification.component';
import { IconModule } from '../../components/icon/icon.module';


@NgModule({
  declarations: [
    NotificationComponent
  ],
  imports: [
    CommonModule,
    IconModule
  ],
  exports: [
    NotificationComponent
  ]
})
export class NotificationModule { }
